export default "__VITE_ASSET__ozS1JBSN__"